import { useIntl } from "react-intl";
import { useState } from "react";
import { Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useDispatch } from 'react-redux';

interface CancelPreinvoiceModalProps {
  openCancelBudgetModal: boolean;
  setOpenCancelBudgetModal: (open: boolean) => void;
  cancelPreinvoice:(value:boolean)=>void;
}

export default function CancelPreinvoiceModal({openCancelBudgetModal, setOpenCancelBudgetModal ,cancelPreinvoice}: CancelPreinvoiceModalProps) {

  const dispatch = useDispatch();
  const intl = useIntl();
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <Modal
      visible={openCancelBudgetModal}
      setVisible={setOpenCancelBudgetModal}
      className="custom-modal w-auto"
      header={<h6 className="modalTitle">{"¿Querés cancelar la prefacturación de este presupuesto?"}</h6>}
      footerButtonRightText = {intl.formatMessage({ id: "YesCancel" })}
      footerButtonLeftText= "No, continuar con la prefacturación"
      onClickLeftBtn = {()=>cancelPreinvoice(false)}
      onClickRightBtn={()=>cancelPreinvoice(true)}
      closable={false}
    >
      <div style={{ minWidth: isMobile ? "" : "150px" }}>
        <div className="flex flex-column gap-2">
          <span>{intl.formatMessage({ id: "UponCancellationTheDataEnteredWillBeLost" })}</span>
        </div>
      </div>
    </Modal>
  );
}
